module.exports = __webpack_public_path__ + "img/deal.985d72a7.svg";